import React, { useState } from 'react';

import { organisationsApi } from '../../../api/organisations';
import { extractErrorMessage } from '../../../api/errors';
import Button from '../../../components/ui/Button';
import Card from '../../../components/ui/Card';
import Input from '../../../components/ui/Input';

const INITIAL = {
  name: '',
  registration_number: '',
  state: '',
  district: '',
  village: '',
  contact_email: '',
  contact_phone: '',
  about: '',
};

export default function OnboardingForm({ onSuccess }) {
  const [form, setForm] = useState(INITIAL);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const org = await organisationsApi.onboard(form);
      onSuccess(org);
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="p-6 sm:p-8">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Onboard your FPO</h2>
        <p className="mt-1 text-sm text-gray-600">
          Tell us about your Farmer Producer Organisation. You can edit any of this later.
        </p>
      </div>
      <form className="mt-6 flex flex-col gap-4" onSubmit={handleSubmit}>
        <Input
          name="name"
          label="FPO name"
          value={form.name}
          onChange={handleChange}
          required
          placeholder="Sahyadri Farmers Producer Company Ltd."
        />
        <Input
          name="registration_number"
          label="Registration number"
          value={form.registration_number}
          onChange={handleChange}
          helpText="As registered under the Societies Act / Producer Company Act"
        />
        <div className="grid gap-4 sm:grid-cols-2">
          <Input
            name="state"
            label="State"
            value={form.state}
            onChange={handleChange}
            required
            placeholder="Maharashtra"
          />
          <Input
            name="district"
            label="District"
            value={form.district}
            onChange={handleChange}
            required
            placeholder="Nashik"
          />
        </div>
        <Input
          name="village"
          label="Headquarters village / town"
          value={form.village}
          onChange={handleChange}
          placeholder="Sinnar"
        />
        <div className="grid gap-4 sm:grid-cols-2">
          <Input
            name="contact_email"
            label="Contact email"
            type="email"
            value={form.contact_email}
            onChange={handleChange}
          />
          <Input
            name="contact_phone"
            label="Contact phone"
            type="tel"
            value={form.contact_phone}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="about" className="text-sm font-medium text-gray-700">
            About (optional)
          </label>
          <textarea
            id="about"
            name="about"
            value={form.about}
            onChange={handleChange}
            rows={3}
            className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
            placeholder="What crops do you grow? How many villages and farmers?"
          />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <Button type="submit" disabled={submitting} size="lg">
          {submitting ? 'Creating FPO…' : 'Create FPO'}
        </Button>
      </form>
    </Card>
  );
}
